import * as actionTypes from "../actionTypes/notifications.types";

const initialState = {
  panelOpen: false,
  items: [],
  hasMore: false,
  loading: false,
  loadingMore: false,
  error: false,
  unreadCount: 0,
  // Push preference toggles — null until fetched.
  enabled: null,
  enabledSaving: false
};

export const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_NOTIFICATIONS_PANEL:
      return { ...state, panelOpen: !state.panelOpen };

    case actionTypes.CLOSE_NOTIFICATIONS_PANEL:
      return { ...state, panelOpen: false };

    case actionTypes.FETCH_NOTIFICATIONS_REQUEST:
      return action.from
        ? { ...state, loadingMore: true }
        : { ...state, loading: true, error: false };

    case actionTypes.FETCH_NOTIFICATIONS_SUCCESS: {
      if (!action.append) {
        return {
          ...state,
          items: action.notifications,
          hasMore: action.hasMore,
          loading: false,
          loadingMore: false
        };
      }
      const knownIds = new Set(state.items.map(n => n.id));
      const fresh = action.notifications.filter(n => !knownIds.has(n.id));
      return {
        ...state,
        items: [...state.items, ...fresh],
        hasMore: action.hasMore,
        loading: false,
        loadingMore: false
      };
    }

    case actionTypes.FETCH_NOTIFICATIONS_FAILED:
      return { ...state, loading: false, loadingMore: false, error: true };

    case actionTypes.FETCH_UNREAD_COUNT_SUCCESS:
      return { ...state, unreadCount: action.count };

    // Optimistic: seen is applied locally on request; the saga resyncs the
    // count if the API call genuinely fails.
    case actionTypes.MARK_NOTIFICATION_SEEN_REQUEST: {
      const target = state.items.find(n => n.id === action.id);
      const wasUnseen = target && !target.is_seen;
      return {
        ...state,
        items: state.items.map(n =>
          n.id === action.id ? { ...n, is_seen: true } : n
        ),
        unreadCount: wasUnseen
          ? Math.max(0, state.unreadCount - 1)
          : state.unreadCount
      };
    }

    case actionTypes.MARK_ALL_NOTIFICATIONS_SEEN_REQUEST:
      return {
        ...state,
        items: state.items.map(n => (n.is_seen ? n : { ...n, is_seen: true })),
        unreadCount: 0
      };

    case actionTypes.NEW_NOTIFICATION_RECEIVED: {
      if (!action.notification) return state;
      if (state.items.some(n => n.id === action.notification.id)) return state;
      return {
        ...state,
        items: [action.notification, ...state.items],
        unreadCount: action.notification.is_seen
          ? state.unreadCount
          : state.unreadCount + 1
      };
    }

    case actionTypes.FETCH_ENABLED_NOTIFICATIONS_SUCCESS:
      return { ...state, enabled: action.enabled };

    case actionTypes.UPDATE_ENABLED_NOTIFICATIONS_REQUEST:
      return { ...state, enabledSaving: true };

    case actionTypes.UPDATE_ENABLED_NOTIFICATIONS_SUCCESS:
      return { ...state, enabled: action.enabled, enabledSaving: false };

    case actionTypes.UPDATE_ENABLED_NOTIFICATIONS_FAILED:
      return { ...state, enabledSaving: false };

    default:
      return state;
  }
};
